<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    :stroke="val ? '#08b64d' : '#ed5051'"
    stroke-width="3"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <polyline v-if="val" points="20 6 9 17 4 12"></polyline>
    <template v-else>
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </template>
  </svg>
</template>

<script>
export default {
  props: {
    val: {
      type: [Boolean, Number],
      default: false,
    },
  },
}
</script>
